export default __webpack_public_path__ + "static/media/vodafoneLogo.85892bb1.png";